import './InstructionBuilder.scss';

import React from 'react';

import IconMap from 'components/shared/ClientMissions/IconMap';
import {isMoneyMarketCutoffEnabled} from 'services/FeatureFlags';

//TODO: Update the note piece of the instruction content for icons
const InstructionBuilder = ({ content, isSweepAccount = false }) => {
  if (!content) {
    return null;
  }
  const { title, subtitle, stepTitle, steps, notes } = content;

  return (
    <div className="modal-step-two">
      <p className="title">{title}</p>
      {subtitle &&
        <p className="subtitle">{subtitle}</p>
      }
      {stepTitle &&
        <p className="step-title">{stepTitle}</p>
      }
      {steps.map((step, i) => (
        <div className="bullet-point" key={i}>
          <IconMap currentIndex={i + 1} action={step.icon} status={step.icon}/>
          <p className="step">{step.content}</p>
        </div>
        ))}

      {notes.map((note, i) =>
        <div key={"note-" + i} className="bullet-point">
          <div className="note-icon">{note.icon}</div>
          {(isMoneyMarketCutoffEnabled() && note.moneyMarketContent && isSweepAccount) ? (
            <p className="note">{note.moneyMarketContent}</p>
          ) : (
          <p className="note">{note.content}</p>
        )}
        </div>
      )}
    </div>
  );
};

export default InstructionBuilder;
